module.exports = __webpack_public_path__ + "fonts/ac742c4.eot";